import './index.css';
import { PortalHeader } from '@portal_components/components/PortalHeader';
import { PortalFooter } from '@portal_components/components/PortalFooter';
import { useUserInfo } from './hooks/useUserInfo';
//import { HistoricDataForm } from './HistoricDataForm';
import { EnvironmentVariables } from './EnvironmentVariables';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Container } from './components/Container';
import { S98FlagsView } from './S98FlagView';

const router = createBrowserRouter([
  {
    path: '',
    element: <Container />,
    children: [
      // {
      //   path: '',
      //   element: <HistoricDataForm />
      // },
      {
        path: '',
        element: <S98FlagsView />
      }
    ]
  }
]);

function App() {
  const { isUserInfoLoading, userInfo } = useUserInfo();

  return (
    <div>
      <PortalHeader title={EnvironmentVariables.UpumApplicationName} userEmail={userInfo?.user} applications={userInfo?.applications} />
      {isUserInfoLoading && <div className="flex flex-row justify-center">Loading User Info...</div>}
      {userInfo && <RouterProvider router={router} />}
      <PortalFooter />
    </div>
  );
}

export default App;
